module.exports = __webpack_public_path__ + "static/media/ma.ce84cacf.png";